var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResource({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1745810469376,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 33711,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.69728 349.99296l472.60672 259.13856a30.3616 30.3616 0 0 0 29.01504 0.08704L995.328 356.736a30.36672 30.36672 0 0 0 0.1792-53.34016L522.91072 44.2624a30.34624 30.34624 0 0 0-29.02016-0.1024L25.87136 296.64768a30.3616 30.3616 0 0 0-0.17408 53.34528z m482.49344-244.54144l409.16992 224.34816-404.34688 218.1376L103.84896 323.584l404.34176-218.13248z",
    fill: "currentColor",
    "p-id": 33712
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.14112 554.86464l472.61184 259.12832a30.3104 30.3104 0 0 0 14.60224 3.7376c4.96128 0 9.91232-1.20832 14.4128-3.64032l468.01408-252.48768a30.3616 30.3616 0 0 0 12.3136-41.12896 30.3616 30.3616 0 0 0-41.14944-12.30848l-453.4784 244.64384-458.13248-251.1872a30.3616 30.3616 0 1 0-29.19424 53.24288z",
    fill: "currentColor",
    "p-id": 33713
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.42688 708.6592a30.35648 30.35648 0 0 0-41.14432-12.30848l-453.47328 244.64896-458.13248-251.19744a30.37184 30.37184 0 0 0-29.19424 53.25312l472.61184 259.12832c4.47488 2.45248 9.49248 3.7376 14.59712 3.73248 4.96128 0 9.91744-1.2032 14.42304-3.64032l468.01408-252.48256a30.37696 30.37696 0 0 0 12.29824-41.13408z",
    fill: "currentColor",
    "p-id": 33714
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResource);
export default __webpack_public_path__ + "static/media/resource.d251f1fe09b462d3b3711457e15399ca.svg";
export { ForwardRef as ReactComponent };